import { useMemo } from 'react';
import { linePath, useWidth } from './scale';

/** De-emphasised trend line with the current value as an accented end dot. */
export function Sparkline({
  values,
  color,
  height = 34,
  label,
}: {
  values: number[];
  color: string;
  height?: number;
  label?: string;
}) {
  const [ref, width] = useWidth<HTMLDivElement>(120);
  const geom = useMemo(() => {
    if (values.length < 2) return null;
    const lo = Math.min(...values);
    const hi = Math.max(...values);
    const span = hi - lo || 1;
    const pad = 5;
    const pts = values.map(
      (v, i) => [pad + (i / (values.length - 1)) * (width - pad * 2), pad + (1 - (v - lo) / span) * (height - pad * 2)] as [number, number],
    );
    return { d: linePath(pts), last: pts[pts.length - 1] };
  }, [values, width, height]);
  return (
    <div ref={ref} className="sparkline" style={{ height }}>
      {geom && (
        <svg width={width} height={height} role="img" aria-label={label ?? 'trend'}>
          <path d={geom.d} fill="none" stroke="var(--ink-3)" strokeOpacity={0.55} strokeWidth={1.5} strokeLinejoin="round" />
          <circle cx={geom.last[0]} cy={geom.last[1]} r={4} fill={color} stroke="var(--surface)" strokeWidth={2} />
        </svg>
      )}
    </div>
  );
}
